'use client';

import { NoticeWithIcon, Spacing } from '~/components';
import { Button } from '@bgzt/ui';
import { Typography } from '@bgzt/ui';

import styles from './ErrorNotice.module.css';

type Props = {
  onResetClick: () => void;
  resetButtonText?: string;
};

export const ErrorNotice = ({ onResetClick, resetButtonText = '다시 불러오기' }: Props) => {
  return (
    <>
      <Spacing height={120} />
      <NoticeWithIcon iconType="error">
        <Spacing height={12} />
        <Typography variant="S1" color="gray-900" as="p" className={styles.text}>
          내용을 불러오지 못했습니다.
          <br />
          다시 시도해 주세요.
        </Typography>
        <Spacing height={20} />
        <Button
          variant="normalLine"
          onClick={() => {
            onResetClick();
          }}
        >
          {resetButtonText}
        </Button>
      </NoticeWithIcon>
    </>
  );
};
